const INTERACTIVE_SELECTOR = 'button, a, input, textarea, select, [contenteditable]';

export function attachSheetSwipe({ panel, backdrop, zones, threshold = 80 }) {
  let startY = null;
  let delta = 0;
  let dismissFallback = null;

  const clearDismissFallback = () => {
    if (dismissFallback != null) {
      clearTimeout(dismissFallback);
      dismissFallback = null;
    }
  };

  const onStart = (e) => {
    if (e.target.closest(INTERACTIVE_SELECTOR)) return;
    clearDismissFallback();
    startY = e.touches[0].clientY;
    delta = 0;
    panel.style.transition = 'none';
  };

  const onMove = (e) => {
    if (startY == null) return;
    delta = e.touches[0].clientY - startY;
    if (delta > 0) {
      e.preventDefault();
      panel.style.transform = `translateY(${delta}px)`;
    }
  };

  const onEnd = () => {
    if (startY == null) return;
    startY = null;
    panel.style.transition = 'transform 0.2s ease-out';
    if (delta > threshold) {
      const done = (e) => {
        if (e.target !== panel || e.propertyName !== 'transform') return;
        panel.removeEventListener('transitionend', done);
        clearDismissFallback();
        backdrop.click();
      };
      dismissFallback = setTimeout(() => {
        panel.removeEventListener('transitionend', done);
        dismissFallback = null;
        backdrop.click();
      }, 300);
      panel.addEventListener('transitionend', done);
      panel.style.transform = 'translateY(100%)';
    } else {
      panel.style.transform = '';
    }
  };

  const onCancel = () => {
    if (startY == null) return;
    startY = null;
    clearDismissFallback();
    panel.style.transition = 'transform 0.2s ease-out';
    panel.style.transform = '';
  };

  zones.forEach((zone) => {
    zone.addEventListener('touchstart', onStart, { passive: true });
    zone.addEventListener('touchmove', onMove, { passive: false });
    zone.addEventListener('touchend', onEnd);
    zone.addEventListener('touchcancel', onCancel);
  });

  return () => {
    clearDismissFallback();
    zones.forEach((zone) => {
      zone.removeEventListener('touchstart', onStart);
      zone.removeEventListener('touchmove', onMove);
      zone.removeEventListener('touchend', onEnd);
      zone.removeEventListener('touchcancel', onCancel);
    });
    panel.style.transform = '';
    panel.style.transition = '';
  };
}
